import { createSlice } from '@reduxjs/toolkit';
import type { IHaveActiveDailyRents } from 'shared/types/features';

const initialState: IHaveActiveDailyRents = {
  value: false,
};

/* istanbul ignore next */
const haveActiveDailyRentsSlice = createSlice({
  initialState,
  name: 'haveActiveDailyRents',
  reducers: {},
});

export const { reducer: haveActiveDailyRentsReducer } = haveActiveDailyRentsSlice;
